import script from "./navigable-screen.vue?vue&type=script&setup=true&lang=ts"
export * from "./navigable-screen.vue?vue&type=script&setup=true&lang=ts"

import "./navigable-screen.vue?vue&type=style&index=0&id=3be850f4&lang=scss"

const __exports__ = script;

export default __exports__